export const environmentqa = {
  production: true,
  environmentName: "QA",
  apiUrl: "",
  testmodu: false,
};
